import RentalTypeOptions from './RentalTypeOptions';

export default RentalTypeOptions;
